/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Card, Alert, Typography, Link
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import ListsHeader from './ListsHeader';

const ListsError = ({ refetchLists, isDashboardSnapshot }) => {

  return (
    <Card
      data-component="Lists"
      data-testid="lists-error-container"
      className="sui-@container sui-h-full"
      // Dashboard Snapshot: the tab already names the tool and the snapshot's cards have no
      // border, so the error drops both, like the empty state.
      PaperProps={isDashboardSnapshot ? { variant: 'shadow', shadow: 'none' } : undefined}
    >
      {!isDashboardSnapshot && (
        <ListsHeader
          listCount={0}
          showLearnMoreLink={false}
          hideActions
          showOnlyCreate
        />
      )}
      <Alert status="error" size="large">
        <div>
          <Typography variant="body-base" weight="bold">Something went wrong during loading</Typography>
          <Typography variant="body-base">
            <Link onClick={refetchLists}>Refresh Lists</Link> to try again.
          </Typography>
        </div>
      </Alert>
    </Card>
  );
};
ListsError.displayName = 'ListsError';
ListsError.propTypes = {
  refetchLists: PropTypes.func,
  isDashboardSnapshot: PropTypes.bool
};
ListsError.defaultProps = {
  refetchLists: () => {},
  isDashboardSnapshot: false
};
export default ListsError;
